module.exports = __webpack_public_path__ + "img/chax.88eb778e.svg";